__turbopack_context__.v({
  "hero-section": "B7w4iW_hero-section",
  "hero-section__badge-container": "B7w4iW_hero-section__badge-container",
  "hero-section__summary-container": "B7w4iW_hero-section__summary-container",
});
